import React from "react";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import useStyles from "./DatePicker.styles";

const DatePickerMonthEnds = ({
  minDate,
  maxDate,
  value,
  onChange,
  onOpenChange,
  isOpen,
  allowedMonthEnds = [],
} = {}) => {
  const { classes } = useStyles();

  const allowedSet = React.useMemo(() => {
    return new Set(
      allowedMonthEnds.map((date) => dayjs(date).format("YYYY-MM-DD")),
    );
  }, [allowedMonthEnds]);

  const disabledDate = (current) => {
    if (!current) return false;

    const currentMonthEnd = current.endOf("month").format("YYYY-MM-DD");

    const isOutsideRange =
      (minDate && current.isBefore(minDate, "month")) ||
      (maxDate && current.isAfter(maxDate, "month"));

    const isNotAllowed =
      allowedSet.size > 0 && !allowedSet.has(currentMonthEnd);

    return isOutsideRange || isNotAllowed;
  };

  return (
    <DatePicker
      picker="month"
      format="MMM YYYY"
      placeholder="Select Month"
      disabledDate={disabledDate}
      value={value}
      onChange={onChange}
      open={isOpen}
      onOpenChange={onOpenChange}
      className={classes.dateField}
    />
  );
};

export default DatePickerMonthEnds;
